import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { TableComponent } from 'app/shared/table/table.component';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientListVm } from '../shared/generated/Clients/Models/ClientListVm';

@Component({
    selector: 'pcg-clients',
    imports: [SharedModule, RouterModule],
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.css']
})
export class ClientsComponent {
	@Input() vendorId: number | null = null;
	@ViewChild(TableComponent, { static: false }) table: TableComponent<ClientListVm>;
	@ViewChild('addToClient', { static: true }) modalContent: TemplateRef<any>;

	columns = ClientListVm.ColumnDefs;
	dataSource = 'api/Clients/Client/GetClientList/';
	deleteUrl = `api/Clients/Client/DeleteClient`;

	constructor(public title: Title, public router: Router, public modalService: NgbModal) {}

	ngOnInit() {
		if (this.vendorId != null) {
			this.dataSource += this.vendorId;
			this.deleteUrl = `api/Clients/Client/DeleteClient`;
			return;
		}

		this.title.setTitle('Client List');
	}

	async reloadTable() {
		this.table.ajaxData;
		this.table.ajaxReload();
	}

	redirectClient(id: Number) {
		this.router.navigateByUrl(`clients/edit-client/${id}`);
	}
}
